/**
 * 工程文件类型的消息
 */
import PropTypes from 'prop-types';
import React from 'react';
import cls from 'classnames';

import MessageContainer from '@/components/message/items/message-container';
import MessageAvatar from '@/components/message/items/message-avatar';

import styles from './styles.module.scss';
import { CDN_BASE_URL } from '@/constants';


const SendingMessage = ({ avatar, fromMe, avatarClassName, senderOid, senderType }) => (
  <MessageContainer fromMe={fromMe}>
    <MessageAvatar
      className={avatarClassName}
      fromMe={fromMe}
      avatar={avatar}
      senderOid={senderOid}
      senderType={senderType}
    />
    <div className={cls(styles.sendingMessage, 'ms-content ms-audio-content', { right: fromMe, left: !fromMe })}>
      <img src={`${CDN_BASE_URL}/miniloading.svg`} alt="..." />
    </div>
  </MessageContainer>
);

SendingMessage.propTypes = {
  fromMe: PropTypes.bool,
  avatar: PropTypes.string,
  avatarClassName: PropTypes.string,
  senderType: PropTypes.string,
  senderOid: PropTypes.string,
};

export default SendingMessage;
